import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { EnrolState, CourseType, CourseStateType } from 'enum'
import { enrolInitialState } from 'models/enrol.model'
import * as fromActions from 'store/actions/enrols.action'
import { ICourseCard } from '../../../../models/courseCard.model'
import { ICardEnrol } from '../types'

interface IUseStartCoursesProps {
  course: ICourseCard
  enrol: ICardEnrol | null
  directToLessons?: boolean
}

export const useStartCourse = ({
  course,
  directToLessons,
  enrol,
}: IUseStartCoursesProps) => {
  const history = useHistory()
  const dispatch = useDispatch()

  const stateAdmin = enrol?.stateAdmin
  const startCourse = useCallback(() => {
    const courseId = course.id

    if (course.state === CourseStateType.Soon) {
      history.push(`/courses/${courseId}/`)
      return
    }

    if (course.normative) {
      history.push(`/courses/${courseId}/`)
      return
    }

    if (directToLessons && course['integrationCourseLink']) {
      window.open(course['integrationCourseLink'])
      return
    }
    const { mandatory, courseType } = course
    if (directToLessons && !course?.synchronousCourse) {
      if (stateAdmin === EnrolState.Approved) {
        if (courseType === CourseType.Open)
          history.push(`/courses/${courseId}/lessons`)
        else history.push(`/courses/${courseId}`)
      } else if (mandatory && courseType === CourseType.Open) {
        const newEnrol = enrolInitialState
        newEnrol.courseId = Number(courseId)
        const isSynchronous = !!course?.synchronousCourse
        dispatch(
          fromActions.Actions.enrolCreate({
            enrol: newEnrol,
            getCourse: false,
            isSynchronous,
          })
        )
      } else history.push(`/courses/${courseId}/`)
    } else history.push(`/courses/${courseId}/`)
  }, [course, directToLessons, dispatch, history, stateAdmin])
  return startCourse
}

export default useStartCourse
